import React from "react";

import { OrderTagFilters } from "./shared/order-tag-filters";
import { useMetaShopTagInclusions } from "./use-meta-shop-order-tag-inclusions";

export function MetaShopOrderTags() {
  const {
    isSynced,
    loading,
    metaShopOrderTagInclusions,
    updateOrderTagByIndex,
    createOrderTagInclusion,
    removeOrderTagInclusion,
  } = useMetaShopTagInclusions();

  return (
    <OrderTagFilters
      title="Meta shop order tags"
      subheader="You can use order tags to tag certain purchases as Meta shop purchases."
      description="Tag Meta Shop orders with the following tags from your Northbeam data"
      isSynced={isSynced}
      loading={loading}
      addButtonText="ADD INCLUSION"
      tagFilters={metaShopOrderTagInclusions}
      updateTagFilters={updateOrderTagByIndex}
      createTagFilters={createOrderTagInclusion}
      removeTagFilters={removeOrderTagInclusion}
    />
  );
}
